import script from "./PackingGuide.vue?vue&type=script&lang=ts&setup=true"
export * from "./PackingGuide.vue?vue&type=script&lang=ts&setup=true"

import "./PackingGuide.vue?vue&type=style&index=0&id=8bdb7672&scoped=true&lang=scss"

import exportComponent from "/Users/jnshul/Documents/tagluffa_i_vue3/main_page/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8bdb7672"]])

export default __exports__